/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO
     */
    SaveTokenUrl: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO {
    if (!('SaveTokenUrl' in value) || value['SaveTokenUrl'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO {
    return FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'SaveTokenUrl': json['SaveTokenUrl'],
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO {
    return FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'SaveTokenUrl': value['SaveTokenUrl'],
    };
}

